import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/ContactForm2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonText("Sending...");
    let response = await fetch("http://localhost:5000/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(formDetails),
    });
    setButtonText("Send");
    let result = await response.json();
    setFormDetails(formInitialDetails);
    if (result.code == 200) {
      setStatus({ succes: true, message: 'Message sent successfully'});
    } else {
      setStatus({ succes: false, message: 'Something went wrong, please try again later.'});
    }
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Get In Touch</h2>             
                 <form action="https://formsubmit.co/5aa615fb6990773634d366b91097dcba" method="POST">
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                    <input type="text" placeholder="First Name" name="FirstName" required/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                    <input type="text" placeholder="Last Name" name="LastName" required/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                    <input type="email" placeholder="Email Address" name="Email" required/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                    <input type="tel" placeholder="Phone No." name="Phone" required/>
                    </Col>
                    <Col size={12} className="px-1">
                    <textarea rows="6" type="tel" name="Message" placeholder="Message" required></textarea>
                    <button type="submit"><span>{buttonText}</span></button>
                    </Col>                   
                  </Row>
                </form> 
                 {/* <form onSubmit={handleSubmit}>
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.lasttName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)}/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" value={formDetails.phone} placeholder="Phone No." onChange={(e) => onFormUpdate('phone', e.target.value)}/>
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea rows="6" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                      <button type="submit"><span>{buttonText}</span></button>
                    </Col>
                    {
                      status.message &&
                      <Col>
                        <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                      </Col>
                    }
                  </Row>
                </form> */}
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
<form action="https://formsubmit.co/5aa615fb6990773634d366b91097dcba" method="POST">
<row>
<Col size={12} sm={6} className="px-1">
<input type="text" placeholder="First Name" name="firstName" required/>
  </Col>
  <Col size={12} sm={6} className="px-1">
<input type="text" placeholder="Last Name" name="LastName" required/>
  </Col>
  <Col size={12} sm={6} className="px-1">
<input type="email" placeholder="Email Address" name="email" required/>
  </Col>
  <Col size={12} sm={6} className="px-1">
<input type="tel" placeholder="Phone No." name="phone" required/>
  </Col>
  <Col size={12} className="px-1">
    <textarea rows="6" type="tel" name="phone" placeholder="Message" required></textarea>
    <button type="submit">Send</button>
  </Col>
 
{/* <input type="text" name="name" required/>
<input type="email" name="email" required/>
<button type="submit">Send</button> */}
</row>                
</form>